import React from 'react';
import {Link} from 'react-router-dom';
import NavPanel from "../components/NavPanel";
import '../styles/Admin.css';
import {URLS} from "../utils/urls";


const SECTIONS: Array<{ href: string, title: string, description: string, icon: JSX.Element }> = [
    {
        href: URLS.ADMIN_USERS_URL,
        title: 'Пользователи',
        description: 'Учётные записи, роли и права доступа',
        icon: <><circle cx="12" cy="8" r="3.5"/><path d="M4.5 20c0-4 3.5-6.5 7.5-6.5s7.5 2.5 7.5 6.5"/></>,
    },
    {
        href: URLS.ADMIN_PAYEES_URL,
        title: 'Получатели платежа',
        description: 'Юрлица (ФОП/ТОВ), реквизиты, логотип и печать для счёта',
        icon: <><rect x="3" y="6" width="18" height="13" rx="1.5"/><path d="M3 10h18M7 15h4"/></>,
    },
    {
        href: URLS.ADMIN_PDF_CONTENT_URL,
        title: 'Содержимое счёта',
        description: 'Тексты, слоганы, реклама, ответственные за счёт и сайт',
        icon: <><path d="M5 4h14v16H5z"/><path d="M8 8h8M8 12h8M8 16h5"/></>,
    },
];


const Admin = () => {
    return (
        <div className='admin page-content-container'>
            <NavPanel/>
            <div className='admin__body page_content_body'>
                <div className='admin__sections-grid'>
                    {
                        SECTIONS.map((section) =>
                            <Link key={section.href} to={section.href}
                                  className='admin__section-card contentWindow'>
                                <span className='admin__section-card-icon'>
                                    <svg width={28} height={28} viewBox="0 0 24 24" fill="none"
                                         stroke="currentColor" strokeWidth={1.7}
                                         strokeLinecap="round" strokeLinejoin="round">
                                        {section.icon}
                                    </svg>
                                </span>
                                <span className='admin__section-card-title'>{section.title}</span>
                                <span className='admin__section-card-description'>{section.description}</span>
                            </Link>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Admin;
